import React from 'react';
import { Input } from '../ui/Input';
import { WordCappedTextarea } from './WordCappedTextarea';
import { REFERRAL_SOURCES, WRITTEN_QUESTIONS } from '../../data/careers';
import type { ApplicationForm, StepProps } from '../../types/careers';
export function StepQuestions({
  form,
  errors,
  onChange
}: StepProps) {
  return <div className="space-y-6" data-id="element-60" data-mp="2ytn5oucn8ntq">
      <p className="text-engage-gray4 text-base leading-relaxed" data-id="element-61" data-mp="2yqr8x9cj856v">
        100 words max each. Plain words beat fancy ones. We're reading for how
        you think, not just what you did.
      </p>

      {WRITTEN_QUESTIONS.map(question => {
      const field = question.name as keyof ApplicationForm;
      return <WordCappedTextarea key={question.name} label={question.label} name={question.name} placeholder={question.placeholder} value={form[field] as string} error={errors[field]} onChange={value => onChange(field, value as never)} data-id="element-62" data-mp="3hj37dl02embq" />;
    })}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-63" data-mp="an1scksxp8q9">
        <Input label="Compensation you're targeting" name="compensation" placeholder="$70,000 / year or $30 / hour" value={form.compensation} error={errors.compensation} onChange={e => onChange('compensation', e.target.value)} data-id="element-64" data-mp="6l6op9nj6j9b" />
        <Input label="How did you hear about us?" name="howDidYouHear" as="select" value={form.howDidYouHear} error={errors.howDidYouHear} onChange={e => onChange('howDidYouHear', e.target.value)} options={REFERRAL_SOURCES} data-id="element-65" data-mp="tkmdphwhpp64" />
      </div>
    </div>;
}